import { State } from '../../types';

export const louisiana: State = {
  name: 'Louisiana',
  abbreviation: 'LA',
  terms: [
        {
      word: 'Atchafalaya',
      phonetic: 'uh-CHA-fuh-LIE-uh',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A distributary of the Mississippi River'
    },
    {
      word: 'Baton Rouge',
      phonetic: 'BAT-un ROOJ',
      description: 'The capital of Louisiana, meaning "Red Stick" in French.'
    },
    {
      word: 'Bayou',
      phonetic: 'BUY-oh',
      description: 'A slow-moving body of water common in the Louisiana wetlands.'
    },
    {
      word: 'Beignets',
      phonetic: 'Ben-YAY',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A French-style powdered donut, popular in New Orleans.'
    },
    {
      word: 'Bogue Chitto',
      phonetic: 'BOHG-chit-uh',
      // audioUrl: '/audio/bogue_chitto.mp3',
      description: 'A state park and river, pronounced "BOHG-chit-uh," not "BOHG-chee-toh."'
    },
    {
      word: 'Bogue Falaya',
      phonetic: 'BOHG-fuh-LIE-uh',
      // audioUrl: '/audio/bogue_falaya.mp3',
      description: 'A river in St. Tammany and Washington parishes, pronounced "BOHG-fuh-LIE-uh," not "BOHG-fuh-LAY-uh."'
    },
    {
      word: "Boudin",
      phonetic: "BOO-dan",
      description: "A Cajun sausage made from pork, rice, and spices, often served in links or as a filling.",
    },
    {
      word: 'Broussard',
      phonetic: 'BROO-sard',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A town near Lafayette with a rich Cajun heritage.'
    },
    {
      word: 'Chartres',
      phonetic: 'CHAR-ter',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A historic street in the French Quarter of New Orleans.'
    },
    {
      word: 'Evangeline',
      phonetic: 'ee-VAN-juh-leen',
      description: 'A symbol of Acadian culture, based on Longfellow’s epic poem.'
    },
    {
      word: "Fais do-do",
      phonetic: "fay-DOE-doe",
      description: "A Cajun dance party, often held in community halls or barns.",
    },
    {
      word: "Gris-gris",
      phonetic: "GREE-gree",
      description: "A voodoo amulet or charm meant to ward off evil or bring good luck.",
    },
    {
      word: 'Grosse Tête',
      phonetic: 'GROHS-tet',
      // audioUrl: '/audio/grosse_tete.mp3',
      description: 'A village in Iberville Parish, pronounced "GROHS-tet," not "GROSS-tayt."'
    },
    {
      word: 'Lafayette',
      phonetic: 'LAF-ee-yet',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A city in southern Louisiana known for its Cajun and Creole culture.'
    },
    {
      word: "Lagniappe",
      phonetic: "LAN-yap",
      description: "A small, unexpected gift given to customers; a hallmark of southern hospitality.",
    },
    {
      word: 'Metairie',
      phonetic: 'MET-uh-ree',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A suburb of New Orleans.'
    },
    {
      word: 'Natchitoches',
      phonetic: 'NAH-code-ish',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A city in Louisiana and the oldest settlement of the Louisiana Purchase.'
    },
    {
      word: 'Opelousas',
      phonetic: 'OH-puh-loo-sas',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A historic city in Louisiana known as the “Spice Capital of the World.”'
    },
    {
      word: 'Ponchartrain',
      phonetic: 'PON-chuh-train',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A large lake in southern Louisiana.'
    },
    {
      word: 'Praline',
      phonetic: 'PRAH-leen',
      description: 'A sweet candy made from sugar, nuts, and cream, often associated with New Orleans.'
    },
    {
      word: "Saint Amant",
      phonetic: "San-A-Mah",
      description: "An unincorporated community in Ascension Paris",
    },
    {
      word: "Second Line",
      phonetic: "SEK-uhnd LYN",
      description: "A traditional parade or procession, often with brass bands, rooted in African-American culture.",
    },
    {
      word: 'Tangipahoa',
      phonetic: 'TAN-juh-pah-HOA',
      // audioUrl: '/audio/tangipahoa.mp3',
      description: 'A river and parish, pronounced "TAN-juh-pah-HOA," not "TAN-gee-pah-HO-ah."'
    },
    {
      word: 'Tchefuncte',
      phonetic: 'chuh-FUNK-tuh',
      // audioUrl: '/audio/tchefuncte.mp3',
      description: 'A river in southwest Louisiana, pronounced "chuh-FUNK-tuh," not "TCHAY-funk-tee."'
    },
    {
      word: 'Tchoupitoulas',
      phonetic: 'CHOP-uh-too-luhs',
      // audioUrl: '/audio/tchoupitoulas.mp3',
      description: 'A street in New Orleans named after a Native American tribe'
    },
    {
      word: 'Thibodaux',
      phonetic: 'TIB-uh-doh',
      // audioUrl: '/audio/atchafalaya.mp3',
      description: 'A small city in southern Louisiana.'
    },
        {
      word: 'Treme',
      phonetic: 'truh-MAY',
      description: 'A historic New Orleans neighborhood known for its jazz heritage.'
    },
    {
      word: "Zydeco",
      phonetic: "ZIGH-duh-co",
      description: "A music genre blending French, African, and Caribbean influences, central to Cajun identity.",
    }
  ]
};
